import {Component, inject, OnInit} from '@angular/core'
import {Router} from '@angular/router'
import {BankIdComponent} from '@vambie/vambie-bankid-fe'
import {filter, first} from 'rxjs'
import {environment} from '../../../environments/environment'
import {ENVIRONMENT} from '../../application/constants'
import {ConfigService} from '../../services/config.service'


@Component({
  selector: 'vmb-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  imports: [
    BankIdComponent
  ],

  providers: [
    {provide: ENVIRONMENT, useValue: environment}
  ]
})
export class LoginComponent implements OnInit {
  protected readonly environment: any = inject(ENVIRONMENT)

  public service = inject(ConfigService)

  private router = inject(Router)

  public ngOnInit(): void {
    this.service.accessToken$.pipe(
      filter(Boolean),
      first()
    ).subscribe({
      next: () => this.router.navigate(['/', 'home'])
    })
  }
}
